import {
  SlideshowItem,
  InternalSlideshowItemProps,
  SlideshowItemImage
} from "./Slideshow";
import { isPresent } from "src/utils/checks";
import { VideoWithPosterImageFragment } from "types/graphql-types";
import { SanityImageType } from "@silversea-ssc/ui-components-react";

export function convertImages(
  items: SlideshowItem[],
  hideCaption: boolean
): InternalSlideshowItemProps[] {
  return items
    .map((item) => {
      const galleryItem =
        item.__typename === "SanityVideoWithPosterImage"
          ? convertVideo(item as VideoWithPosterImageFragment)
          : converImage(item as SlideshowItemImage, hideCaption);

      if (!galleryItem) return undefined;

      return {
        key: `slideshow-${item._key}`,
        original: item._key,
        ...galleryItem
      };
    })
    .filter(isPresent);
}

function converImage(
  item: SlideshowItemImage,
  hideCaption: boolean
): InternalSlideshowItemProps | undefined {
  if (!item.asset?._id) return undefined;
  const caption = "caption" in item ? item.caption?.localized || " " : " ";

  return {
    image: item as SanityImageType,
    isVideo: false,
    description: hideCaption ? undefined : caption
  };
}

function convertVideo(
  item: VideoWithPosterImageFragment
): InternalSlideshowItemProps | undefined {
  const image = item.posterImage;
  if (!image?.asset?._id) return undefined;

  return {
    image: image as SanityImageType,
    isVideo: true,
    video: {
      file: item.file,
      trackingTitle: item.trackingTitle
    }
  };
}
